module.exports = __webpack_public_path__ + "img/logo-believe-specialist-finance.e3af5a68.svg";